import { connect } from 'react-redux'
import { selectRecipients } from 'ducks/drafts'
import Header from './view'

const select = state => ({
  recipients: selectRecipients(state),
})

export default connect(select)(Header)
